import sendFormAsync from './send-form-async';

const captcha = {};

let isLoaded = false;

let isLoading = false;

const callbacks = [];

captcha.load = () => {
  if (isLoading || isLoaded) return;
  isLoading = true;
  const script = document.createElement('script');
  script.addEventListener('load', () => {
    window.grecaptcha.ready(() => {
      let cb;
      isLoaded = true;
      while (cb = callbacks.shift()) {
        cb();
      }
    });
  });
  script.setAttribute('src', `https://www.google.com/recaptcha/api.js?render=${window.captchaKey}`);
  document.body.appendChild(script);
};

captcha.ready = (cb) => {
  if (isLoaded) {
    setTimeout(cb, 0);
  } else {
    callbacks.push(cb);
    if (!isLoading) {
      captcha.load();
    }
  }
};

captcha.protectForm = (form) => {
  const input = document.createElement('input');
  input.setAttribute('type', 'hidden');
  input.setAttribute('name', 'recaptcha_response');
  form.appendChild(input);
  captcha.ready(() => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      window.grecaptcha.execute(window.captchaKey).then((token) => {
        input.value = token;
        sendFormAsync(form);
      });
    });
  });
};

export default captcha;
